import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'movement-v2',
		path: '/v2/m/:movementId',
		component: loadable(async () => import(/* webpackChunkName: "pages/movement_v2" */ './index'), {
			exportName: 'MovementV2',
			fallback: Loading,
		}),
		frame: true,
		restrictedAccess: {
			authOnly: true,
			role: ['staff'],
		},
		ssr: {
			enabled: true,
			seo: true,
		},
	},
];
